/* BARE MINIMUM — CRO redesign helpers */
(function () {
  'use strict';

  /* S6 — Re-enable pinch-zoom. Third-party checkout scripts inject extra
     viewport tags with user-scalable=no; keep only one accessible tag. */
  function fixViewport() {
    var metas = document.querySelectorAll('meta[name="viewport"]');
    metas.forEach(function (m, i) {
      if (i === 0) m.setAttribute('content', 'width=device-width,initial-scale=1');
      else if (m.parentNode) m.parentNode.removeChild(m);
    });
  }
  fixViewport();
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      for (var j = 0; j < list[i].addedNodes.length; j++) {
        var n = list[i].addedNodes[j];
        if (n.nodeName === 'META' && n.name === 'viewport') { fixViewport(); return; }
      }
    }
  }).observe(document.head, { childList: true });

  /* Scroll reveal for bm sections */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.bm-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  document.addEventListener('DOMContentLoaded', function () { initReveal(); });
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });

  /* FAQ accordion: one open at a time within a group */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('details[data-bm-accordion]') || !d.open) return;
    var group = d.closest('[data-bm-accordion-group]');
    if (!group) return;
    group.querySelectorAll('details[data-bm-accordion]').forEach(function (o) { if (o !== d) o.open = false; });
  }, true);
})();

/* ---------- Page enhancements that avoid editing large vendor sections ---------- */
(function () {
  'use strict';

  /* D1 — Money format with thousand separators (Rs. 1,599.00), matching Liquid.
     Runs again at DOMContentLoaded because header.js (loaded later) defines its own. */
  function patchMoney() {
    var sample = window.PQ_MONEY_SAMPLE || (window.pqHeaderConfig && window.pqHeaderConfig.moneySample) || 'Rs. 12,345.67';
    var first = sample.search(/\d/), lastM = sample.match(/\d(?=[^\d]*$)/);
    var prefix = first > -1 ? sample.slice(0, first) : '';
    var suffix = lastM ? sample.slice(lastM.index + 1) : '';
    var decimals = /[.,]\d{2}(?!\d)/.test(sample);
    window.formatMoney = function (cents) {
      if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
      var parts = (cents / 100).toFixed(decimals ? 2 : 0).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return prefix + parts.join('.') + suffix;
    };
  }
  window.bmPatchMoney = patchMoney;
  document.addEventListener('DOMContentLoaded', patchMoney);
  window.addEventListener('load', patchMoney);

  /* H3 / C5 — Sold-out products always last in product grids */
  function soldOutLast(root) {
    (root || document).querySelectorAll('.pq-fc__grid, #col-grid, .pq-rp__grid').forEach(function (grid) {
      var cards = Array.prototype.filter.call(grid.children, function (c) { return c.matches('[data-pq-card]') && c.querySelector('.pq-card__badge--out'); });
      cards.forEach(function (c) { grid.appendChild(c); });
      var tile = grid.querySelector('.bm-promo-tile:last-child');
      if (tile && cards.length) grid.appendChild(tile);
    });
  }

  /* C6 — Insert promo tiles to balance the collection grid */
  function promoTiles() {
    var grid = document.getElementById('col-grid');
    var t1 = document.getElementById('bm-promo-1'), t2 = document.getElementById('bm-promo-2');
    if (!grid || !t1 || grid.querySelector('.bm-promo-tile')) return;
    if (/[?&]page=([2-9]|\d{2,})/.test(location.search)) return;
    var cards = grid.querySelectorAll('[data-pq-card]');
    if (cards.length < 4) return;
    cards[3].after(t1.content.cloneNode(true));
    if (t2) grid.appendChild(t2.content.cloneNode(true));
  }

  /* P5 / P6 — Product page: clearer accordion label + HTML size table in the size-guide modal */
  function productPage() {
    document.querySelectorAll('.sp-block--description .sp-accordion__trigger > span:first-child').forEach(function (s) {
      if (s.textContent.trim() === 'Description') s.textContent = 'Product details';
    });
    var tpl = document.getElementById('bm-size-modal');
    if (tpl) {
      document.querySelectorAll('[id^="sp-size-chart-"] .sp-modal__content').forEach(function (c) {
        if (c.querySelector('.bm-st')) return;
        c.innerHTML = '';
        c.appendChild(tpl.content.cloneNode(true));
      });
    }
    if (document.querySelector('.sp-sticky-bar')) document.body.classList.add('bm-has-sticky-atc');
  }

  function run() {
    patchMoney();
    soldOutLast();
    promoTiles();
    productPage();
    var results = document.getElementById('col-results');
    if (results && !results._bmObs) {
      results._bmObs = true;
      new MutationObserver(function () { soldOutLast(results); promoTiles(); }).observe(results, { childList: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

/* ---------- C3 — Product card merchandising (badges, save %, sizes) ---------- */
(function () {
  'use strict';
  var data = null;
  function load() {
    if (data) return data;
    var el = document.getElementById('bm-pdata');
    try { data = el ? JSON.parse(el.textContent) : {}; } catch (e) { data = {}; }
    return data;
  }
  function decorate() {
    var d = load();
    document.querySelectorAll('[data-pq-card][data-id]:not([data-bm-done])').forEach(function (card) {
      card.setAttribute('data-bm-done', '');
      var p = d[card.dataset.id];
      if (!p) return;
      var badges = card.querySelector('.pq-card__badges');
      if (badges && p.a) {
        if (p.best) badges.insertAdjacentHTML('beforeend', '<span class="pq-card__badge--bm pq-card__badge--best">Bestseller</span>');
        else if (p.new) badges.insertAdjacentHTML('beforeend', '<span class="pq-card__badge--bm pq-card__badge--new">New</span>');
        if (p.low) badges.insertAdjacentHTML('beforeend', '<span class="pq-card__badge--bm pq-card__badge--low">Few left</span>');
      }
      var row = card.querySelector('[data-card-price-container]');
      if (row && p.save > 0 && !row.querySelector('.pq-card__save')) row.insertAdjacentHTML('beforeend', '<span class="pq-card__save">Save ' + p.save + '%</span>');
      if (row && p.a && p.sizes && p.sizes.length > 1) {
        var h = '<div class="pq-card__sizes" aria-label="Available sizes">' + p.sizes.map(function (s) {
          return '<span class="pq-card__size' + (s[1] ? '' : ' is-out') + '"' + (s[1] ? '' : ' title="Sold out"') + '>' + String(s[0]).replace(/</g, '&lt;') + '</span>';
        }).join('') + '</div>';
        row.insertAdjacentHTML('afterend', h);
      }
    });
  }
  var queued = false;
  function start() {
    decorate();
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; decorate(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
